import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {Redirect, Route} from 'react-router-dom';
import {useTheme, makeStyles} from '@material-ui/core/styles';
import { getUserInfo } from '../../../../shared/src/services/UserService';

import NavRoutes from '../../constants/NavRoutes';

import clsx from 'clsx';
import Users from '../users/Users';
import InterpretingPhysicians from '../interpretingPhysicians/InterpretingPhysicians';
import Cases from '../cases/Cases';
import Configurations from '../configurations/Configuration';
import Topbar from './Topbar';
import Patient from '../patient/Patient';
import Surgeon from '../surgeon/Surgeon';
import SurgeonForms from '../surgeon-forms/SurgeonForms';
import SurgeonFormView from '../surgeon-forms/SurgeonFormView';
import './Home.scss';
import {BASE_ROUTE} from '../../constants/BaseRoute';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
  },
  content: {
    height: '100%',
  },
}));

function withNavThemeHook(Components: any) {
  return function WrappedComponent(props: any) {
    const theme = useTheme();
    const classes = useStyles();
    return <Components {...props} navTheme={theme} navClasses={classes} />;
  };
}

class Home extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      sideBarSmallScreen: false,
      userType: '',
      modules: [],
      accessLoaded: false
    };
  }

  componentDidMount() {
    getUserInfo()
      .then((response: any) => {
        const user = response?.user || response;
        this.setState({
          userType: user?.user_type || '',
          modules: response?.modules || [],
          accessLoaded: true
        });
      })
      .catch(() => {
        this.setState({ accessLoaded: true });
      });
  }

  canViewModule(moduleNameId: string): boolean {
    const { userType, modules } = this.state;
    const isSuperAdmin = ['super_admin', 'admin'].includes(userType);
    return isSuperAdmin || modules.includes(moduleNameId);
  }

  getDefaultHomePath(): string {
    const routePrefix = `/${BASE_ROUTE}/${NavRoutes.PRIVATE.HOME}`;
    if (this.canViewModule('users')) {
      return `${routePrefix}/${NavRoutes.PRIVATE.USERS}`;
    }
    if (this.canViewModule('interpreting_physicians')) {
      return `${routePrefix}/${NavRoutes.PRIVATE.INTERPRETING_PHYSICIANS}`;
    }
    if (this.canViewModule('cases')) {
      return `${routePrefix}/${NavRoutes.PRIVATE.CASES}`;
    }
    if (this.canViewModule('configurations')) {
      return `${routePrefix}/${NavRoutes.PRIVATE.CONFIGURATIONS}`;
    }
    if (this.canViewModule('patients')) {
      return `${routePrefix}/${NavRoutes.PRIVATE.PATIENTPORTAL}`;
    }
    return `${routePrefix}/${NavRoutes.PRIVATE.USERS}`;
  }

  renderHomeRoutes() {
    const { accessLoaded } = this.state;
    if (!accessLoaded) {
      return null;
    }

    return (
      <Fragment>
        {this.props?.location?.pathname ===
          `/${BASE_ROUTE}/${NavRoutes.PRIVATE.HOME}` && (
          <Redirect
            from={`/${BASE_ROUTE}/${NavRoutes.PRIVATE.HOME}`}
            to={this.getDefaultHomePath()}
            exact
          />
        )}
        <Route
          path={`/${BASE_ROUTE}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.USERS}`}
          component={Users}
        />
        {this.canViewModule('interpreting_physicians') && (
          <Route
            path={`/${BASE_ROUTE}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.INTERPRETING_PHYSICIANS}`}
            component={InterpretingPhysicians}
          />
        )}
        {this.canViewModule('cases') && (
          <Route
            path={`/${BASE_ROUTE}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.CASES}`}
            component={Cases}
          />
        )}
        {this.canViewModule('configurations') && (
          <Route
            path={`/${BASE_ROUTE}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.CONFIGURATIONS}`}
            component={Configurations}
          />
        )}
        {this.canViewModule('patients') && (
          <Route
            path={`/${BASE_ROUTE}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.PATIENTPORTAL}`}
            component={Patient}
          />
        )}
        {this.canViewModule('surgeons') && (
          <Route
            path={`/${BASE_ROUTE}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.SURGEONS}`}
            component={Surgeon}
          />
        )}
        {this.canViewModule('surgeon_forms') && (
          <Route
            path={`/${BASE_ROUTE}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.SURGEON_FORMS}/:id/view`}
            component={SurgeonFormView}
            exact
          />
        )}
        {this.canViewModule('surgeon_forms') && (
          <Route
            path={`/${BASE_ROUTE}/${NavRoutes.PRIVATE.HOME}/${NavRoutes.PRIVATE.SURGEON_FORMS}`}
            component={SurgeonForms}
            exact
          />
        )}
      </Fragment>
    );
  }

  render() {
    const {navClasses: classes} = this.props;
    return (
      <div
        className={clsx({
          [classes.root]: true,
        })}>
        <Topbar />
        <main className={classes.content}>{this.renderHomeRoutes()}</main>
      </div>
    );
  }
}

// type state = {
//   auth: {
//     oauth?: string;
//   };
// };

function mapStateToProps(state: any): any {
  // Properties defined here (read from state) will be available as props in the component
  return {
    userName: state.patientInfo.userName,
  };
}

export default connect(mapStateToProps, {})(withNavThemeHook(Home));